import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from 'primereact/button';
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Fieldset} from "primereact/fieldset";
import axios from "axios";
import Cookies from "js-cookie";

const buildPayloadItems = (items = []) => {
  return items
    .map((item, index) => {
      const mapped = {
        name: item?.name,
        label: item?.label,
        sort: index + 1,
        related_to: item?.related_to,
      };
      if (item?.id) {
        mapped.id = item.id;
      }
      return mapped;
    })
    .filter((item) => item.name && item.label && item.related_to);
};

const _FM_GirpadditionalfieldcollectionFormComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const {id} = useParams();

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    items: [],
  });
  const [newItem, setNewItem] = useState({
    name: '',
    label: '',
    related_to: null,
  });
  const [loading, setLoading] = useState(false);

  const relatedToOptions = [
    {label: t('related_to_customer'), value: 'RELATED_TO_CUSTOMER'},
    {label: t('related_to_reservation_group'), value: 'RELATED_TO_RESERVATION_GROUP'},
    {label: t('related_to_reservation'), value: 'RELATED_TO_RESERVATION'},
  ];

  const syncSort = (items = []) => items.map((item, index) => ({
    ...item,
    sort: index + 1,
  }));

  const onSubmit = (closeAfterSave = false) => {
    setLoading(true);

    const payload = {
      name: formData.name,
      description: formData.description,
      items: buildPayloadItems(formData.items),
    };

    const request = formData?.id
      ? axios.patch(
        process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/girp-additional-field-collection/" + formData.id,
        payload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        }
      )
      : axios.post(
        process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/girp-additional-field-collection",
        payload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        }
      );

    request
      .then(response => {
        const nextData = response?.data?.data || formData;
        setFormData({
          ...nextData,
          items: syncSort(nextData?.items || []),
        });
        setLoading(false);
        window.App.toastShow('success', t('success'), response?.data?.message || t('success'));
        window.App.setState({
          rerenderGirpAdditionalFieldCollectionList: Math.random(),
        })

        if (closeAfterSave === true) {
          navigate('/girp-additional-field-collection');
        }
      })
      .catch(error => {
        setLoading(false);
        window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response)
      })
  }

  useEffect(() => {
    if (!id) {
      return;
    }

    setLoading(true)
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/girp-additional-field-collection/" + id,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const fetchedData = response?.data?.data || {};
        setLoading(false)
        setFormData({
          ...fetchedData,
          items: syncSort(fetchedData?.items || []),
        });
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setLoading(false)
      })
  }, [id])

  return (
    <>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid"}>
          <div className={"p-col"}>
            <h2 className={"p-m-0"}>{t('girp_additional_field_collection_form')}</h2>
          </div>
          <div className={"p-col p-text-right p-col-align-center"}>
            <Button type="button" aria-label={t('save')} icon={"pi pi-save"}
                    loading={loading}
                    onClick={() => {
                      onSubmit(false)
                    }}
                    className="p-button-success p-ml-2"/>
            <Button type="button" aria-label={t('save_and_close')}
                    loading={loading}
                    onClick={() => {
                      onSubmit(true)
                    }}
                    className="p-button-success p-ml-2">
                <span>
                  <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                </span>
            </Button>
            <Button type="button"
                    icon={"pi pi-times"}
                    onClick={() => {
                      navigate('/girp-additional-field-collection')
                    }}
                    className="p-button-secondary close p-ml-2">
            </Button>
          </div>
        </div>

        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="name">{t('name')}</label>
              <InputText id="name"
                         value={formData.name || ''}
                         onChange={(e) => {
                           setFormData({
                             ...formData,
                             name: e.target.value
                           })
                         }}/>
            </div>
          </div>
          <div className={"p-col-12"}>
            <div className="p-field p-fluid">
              <label htmlFor="description">{t('description')}</label>
              <InputText id="description"
                         value={formData.description || ''}
                         onChange={(e) => {
                           setFormData({
                             ...formData,
                             description: e.target.value
                           })
                         }}/>
            </div>
          </div>
        </div>
      </Panel>

      <Panel className={"p-mt-3"}>
        <h3 className={"p-mt-0"}>{t('items')}</h3>

          <DataTable
            className={"item-add-table"}
            size={"small"}
            value={formData.items || []}
          reorderableRows
          onRowReorder={(event) => {
            const sortedItems = syncSort(event.value || []);
            setFormData({
              ...formData,
              items: sortedItems,
            })
          }}
          responsiveLayout={window.App.state.responsiveLayout}
            breakpoint="1365px"
            emptyMessage={t('empty_message')}
            stripedRows
            tableStyle={{tableLayout: 'fixed'}}
          >
            <Column rowReorder style={{width: '3rem'}}/>
            <Column field="sort" header={t('sort')} style={{width: '90px'}}/>
            <Column header={t('id')} body={(rowData, options) => (
              <InputText
                className={"p-inputtext-sm"}
                style={{width: '100%', maxWidth: '220px'}}
                value={rowData.name || ''}
                onChange={(e) => {
                  const nextItems = [...(formData.items || [])];
                nextItems[options.rowIndex] = {
                  ...nextItems[options.rowIndex],
                  name: e.target.value,
                };
                setFormData({...formData, items: nextItems});
                }}
              />
            )} style={{width: '240px'}}/>
            <Column header={t('label')} body={(rowData, options) => (
              <InputText
                className={"p-inputtext-sm"}
                style={{width: '100%', maxWidth: '220px'}}
                value={rowData.label || ''}
                onChange={(e) => {
                  const nextItems = [...(formData.items || [])];
                nextItems[options.rowIndex] = {
                  ...nextItems[options.rowIndex],
                  label: e.target.value,
                };
                setFormData({...formData, items: nextItems});
                }}
              />
            )} style={{width: '240px'}}/>
            <Column header={t('related_to')} body={(rowData, options) => (
              <Dropdown 
                options={relatedToOptions}
                className={"p-inputtext-sm"}
                style={{width: '100%', maxWidth: '240px'}}
                placeholder={t('related_to')}
                optionLabel="label"
                optionValue="value"
              value={rowData.related_to || null}
              onChange={(e) => {
                const nextItems = [...(formData.items || [])];
                nextItems[options.rowIndex] = {
                  ...nextItems[options.rowIndex],
                  related_to: e.value,
                };
                  setFormData({...formData, items: nextItems});
                }}
              />
            )} style={{width: '260px'}}/>
            <Column body={(rowData, options) => (
              <Button icon="pi pi-trash" className="p-button-sm p-button-danger p-p-1"
                      tooltip={t('delete')}
                    tooltipOptions={{position: 'left'}}
                    onClick={() => {
                      const nextItems = [...(formData.items || [])];
                      nextItems.splice(options.rowIndex, 1);
                      setFormData({...formData, items: syncSort(nextItems)});
                    }}
            />
          )} className={"p-text-right"} style={{width: '70px'}}/>
        </DataTable>

        <Fieldset
          className={"item-add p-mt-3"}
          legend={<span className={"item-add-legend"}><i
            className={"pi pi-plus"}></i><span>{t('add_new_item_label')}</span></span>}
        >
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4 grid-col-label-input"}>
              <div className="p-field p-fluid">
                <label htmlFor="item_name">{t('id')}</label>
                <InputText id="item_name"
                           className={"p-inputtext-sm"}
                           value={newItem.name || ''}
                           onChange={(e) => {
                             setNewItem({
                               ...newItem,
                               name: e.target.value
                             })
                           }}
                           placeholder={t('id')}
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-4 grid-col-label-input"}>
              <div className="p-field p-fluid">
                <label htmlFor="item_label">{t('label')}</label>
                <InputText id="item_label"
                           className={"p-inputtext-sm"}
                           value={newItem.label || ''}
                           onChange={(e) => {
                             setNewItem({
                               ...newItem,
                               label: e.target.value
                             })
                           }}
                           placeholder={t('label')}
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-4 grid-col-label-input"}>
              <div className="p-field p-fluid">
                <label htmlFor="item_related_to">{t('related_to')}</label>
                <Dropdown  options={relatedToOptions}
                          placeholder={t('related_to')}
                          optionLabel="label"
                          optionValue="value"
                          id={"item_related_to"}
                          emptyMessage={t('empty_message')}
                          onChange={(e) => {
                            setNewItem({
                              ...newItem,
                              related_to: e.value
                            })
                          }}
                          value={newItem.related_to || null}
                          className={"p-p-0"}
                          showClear
                />
              </div>
            </div>
          </div>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-text-right"}>
              <Button icon="pi pi-plus" className="p-button-sm p-button-success p-p-1"
                      label={t('save_new_item_label')}
                      tooltip={t('add')}
                      disabled={!newItem.name || !newItem.label || !newItem.related_to}
                      tooltipOptions={{position: 'left'}}
                      onClick={() => {
                        const nextItems = syncSort([
                          ...(formData.items || []),
                          {
                            ...newItem,
                          }
                        ]);
                        setFormData({
                          ...formData,
                          items: nextItems,
                        })
                        setNewItem({
                          name: '',
                          label: '',
                          related_to: null,
                        })
                      }}
              />
            </div>
          </div>
        </Fieldset>
      </Panel>
    </>
  )
}

export default withTranslation('common')(_FM_GirpadditionalfieldcollectionFormComponent);
